<template>
    <div>
        <h1 class="mt-16 flex w-full justify-center text-xl md:text-3xl font-semibold text-ihh-midnight-gray pb-5">Your account has been created</h1>
        <div class="flex justify-center mt-10 mb-8">
            <p class="w-2/3">Thank you for creating your account at In His Hands Birth Supply. Your account details have been emailed to {{ email }}.</p>
        </div>
        <div class="flex justify-center">
            <router-link to="/">
                <button class=" mt-6 mb-24 ext-sm md:text-base text-ihh-midnight-gray py-3 px-8 rounded-lg bg-ihh-dark-salmon hover:bg-ihh-salmon delay-100 transition tracking-wide">Continue Shopping</button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: ['email'],
}
</script>

<style>

</style>
